import { render } from "./GoogleIcon.vue?vue&type=template&id=52f72cd4&scoped=true"
import script from "./GoogleIcon.vue?vue&type=script&lang=js"
export * from "./GoogleIcon.vue?vue&type=script&lang=js"

import "./GoogleIcon.vue?vue&type=style&index=0&id=52f72cd4&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f72cd4"]])

export default __exports__